import { render, staticRenderFns } from "./OptionBoolean.vue?vue&type=template&id=0dd87508&"
import script from "./OptionBoolean.vue?vue&type=script&lang=js&"
export * from "./OptionBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports